import type IParticipationListEntryViewModel from './participation-list-entry.view-model';
import type LegReport from '../../../../models/leg-report.api-model';
import LegReportApiModel from '../../../../models/leg-report.api-model';

export default class ParticipationListEntryApiModel {
  public rank!: number;
  public participationName!: string;
  public participationId!: number;
  public schoolName!: string;
  public schoolId!: number;
  public municipalityGid!: string;
  public weightedTotalScore!: number;
  public latestFinishedLegReport?: LegReport;
  public latestFinishedLegReportWeightedScore!: number;
  public latestFinishedLegReportLimit!: number;
  public hasLegReports!: boolean;

  public static mapToBusinessModel(apiModel: ParticipationListEntryApiModel): IParticipationListEntryViewModel {
    return {
      rank: apiModel.rank,
      participationName: apiModel.participationName,
      participationId: apiModel.participationId,
      schoolName: apiModel.schoolName,
      schoolId: apiModel.schoolId,
      municipalityGid: apiModel.municipalityGid,
      weightedTotalScore: apiModel.weightedTotalScore,
      latestFinishedLegReport: apiModel.latestFinishedLegReport ? LegReportApiModel.mapToBusinessModel(apiModel.latestFinishedLegReport) : undefined,
      latestFinishedLegReportWeightedScore: apiModel.latestFinishedLegReportWeightedScore,
      latestFinishedLegReportLimit: apiModel.latestFinishedLegReportLimit,
      hasLegReports: apiModel.hasLegReports,
    };
  }
}
